import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import { Row, Col, Button, Image, Spin } from "antd";
// import { QrcodeOutlined } from "@ant-design/icons";
import logoSurgeryTracker from "../../../styles/images/loghi/surgeryTracker.png";
import { Form, Item, Select, Input } from "../../form";
import { getOspedali } from "../../../modules/common";
import { isMobileMode } from "../../../modules/configuration";
import {
  AZIENDA_SANITARIA_LABEL,
  AZIENDA_SANITARIA_MESSAGE,
  AZIENDA_SANITARIA_PLACEHOLDER,
  STRUTTURA_SANITARIA_LABEL,
  STRUTTURA_SANITARIA_MESSAGE,
  STRUTTURA_SANITARIA_PLACEHOLDER,
  ID_PAZIENTE_LABEL,
  ID_PAZIENTE_MESSAGE,
  ID_PAZIENTE_PLACEHOLDER,
  ACCEDI,
  RESET,
  // ACQUISIZIONE_FOTOCAMERA,
  SPINNING_INTERVENTO,
  QR_CODE_ERRATO_TITLE,
  QR_CODE_ERRATO_MESSAGE,
} from "../../../modules/language";
import {
  fetchInfoIntervento,
  resetFetchInfoInterventoEnded,
  fetchInfoInterventoEnded,
  resetInfoIntervento,
  setRicercaEffettuata,
  stopPolling,
  getInfoIntervento,
  getInfoStruttura,
  getRicercaEffettuata,
} from "../../../modules/surgery";
import { notificationCodes, resetNotification, setNotification } from "../../../modules/notification";
import { PATH_MONITORA } from "../../../path";
import { getMessageString } from "../../../tools";
import { QRCodeScanner } from "./QRCodeScanner";

const AZIENDA_SANITARIA = "aziendaSanitaria";
const STRUTTURA_SANITARIA = "strutturaSanitaria";
const ID_PAZIENTE = "codiceIdentificativo";

const CercaBase = ({ intl, history }) => {
  const dispatch = useDispatch();
  const [listaStrutture, setListaStrutture] = useState([]);
  const [selectStruttureEnabled, setSelectStruttureEnabled] = useState(false);
  const [ricercaButtonPressed, setRicercaButtonPressed] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const mobileMode = useSelector(isMobileMode);
  const ospedali = useSelector(getOspedali);
  const infoIntervento = useSelector(getInfoIntervento);
  const infoInterventoEnded = useSelector(fetchInfoInterventoEnded);
  const infoStruttura = useSelector(getInfoStruttura);
  const ricercaFinished = useSelector(getRicercaEffettuata);
  const [form] = Form.useForm();

  useEffect(() => {
    if (ricercaFinished && infoIntervento && infoIntervento !== undefined) {
      dispatch(setRicercaEffettuata(false));
      dispatch(resetInfoIntervento());
      dispatch(stopPolling())
    }
    // eslint-disable-next-line
  }, []);

  const onSelezioneAziendaSanitaria = (e) => {
    const azienda = e.target.value.length > 0 ? e.target.value[0] : null;
    let strutture = [];
    let selectEnabled = false;
    if (azienda) {
      strutture = ospedali.find((ospedale) => ospedale.id.toString() === azienda.toString()).strutture;
      if (strutture && strutture !== undefined && strutture.length === 1)
        form.setFields([{ name: STRUTTURA_SANITARIA, value: [strutture[0].id] }]);
      selectEnabled = true;
    } else {
      form.setFields([{ name: STRUTTURA_SANITARIA, value: undefined }]);
      form.validateFields([STRUTTURA_SANITARIA]);
    }
    setListaStrutture(strutture);
    setSelectStruttureEnabled(selectEnabled);
  };

  useEffect(() => {
    if (ricercaButtonPressed && infoInterventoEnded) {
      setRicercaButtonPressed(false);
      dispatch(resetFetchInfoInterventoEnded());
      if (infoIntervento) {
        history.push(PATH_MONITORA);
        dispatch(setRicercaEffettuata(true));
        resetFields();
      }
    }
    // eslint-disable-next-line
  }, [infoIntervento, ricercaButtonPressed, infoInterventoEnded]);

  useEffect(() => {
    if (infoStruttura && infoStruttura !== undefined) {
      const strutture = ospedali.find((ospedale) => ospedale.id.toString() === infoStruttura.idEnte.toString()).strutture; //prettier-ignore
      setListaStrutture(strutture);
      setSelectStruttureEnabled(true);
      form.setFields([
        { name: AZIENDA_SANITARIA, value: [infoStruttura.idEnte] },
        { name: STRUTTURA_SANITARIA, value: [infoStruttura.idStruttura] },
      ]);
      setTimeout(() => {
        document.getElementById("formRicerca_codiceIdentificativo").focus();
      }, 100);
    }
    // eslint-disable-next-line
  }, [infoStruttura]);

  const resetFields = () => {
    form.resetFields();
    setListaStrutture([]);
    setSelectStruttureEnabled(false);
    setRicercaButtonPressed(false);
  };

  // const onOpenScanner = () => {
  //   dispatch(resetNotification());
  //   resetFields();
  //   setModalVisible(true);
  // };

  const onScanSuccess = (data) => {
    const qrCode = data.split(",");
    if (qrCode && qrCode !== undefined && qrCode.length === 3) {
      const aziendaSanitaria = ospedali.find((ospedale) => ospedale.id.toString() === qrCode[0].toString());
      if (aziendaSanitaria && aziendaSanitaria !== undefined) {
        setListaStrutture(aziendaSanitaria.strutture);
        setSelectStruttureEnabled(true);
        form.setFields([
          { name: AZIENDA_SANITARIA, value: [qrCode[0]] },
          { name: STRUTTURA_SANITARIA, value: [qrCode[1]] },
          { name: ID_PAZIENTE, value: qrCode[2] },
        ]);
        onSubmit();
      }
    } else dispatch(setNotification(notificationCodes.WARNING, QR_CODE_ERRATO_TITLE, QR_CODE_ERRATO_MESSAGE, 5));
    setModalVisible(false);
  };

  const onSubmit = () => {
    dispatch(resetNotification());
    form
      .validateFields()
      .then((values) => {
        setRicercaButtonPressed(true);
        dispatch(fetchInfoIntervento(values[STRUTTURA_SANITARIA][0], values[ID_PAZIENTE]));
      })
      .catch((error) => console.log("ERROR", error));
  };

  return (
    <Spin
      className="spinningIntervento"
      tip={getMessageString(intl, SPINNING_INTERVENTO)}
      spinning={ricercaButtonPressed && !infoInterventoEnded}
    >
      <div className={mobileMode ? "formRicercaMobile" : "formRicerca"}>
        <h1>Surgery Tracker - Ricerca Intervento</h1>
        <div className="logo">
          <Image id="logoSurgeryRicerca" alt="Logo Surgery Tracker" src={logoSurgeryTracker} preview={false} />
        </div>
        <Form className={mobileMode ? "mobileForm" : "desktopForm"} form={form} name="formRicerca">
          <span className="itemLabel">{getMessageString(intl, AZIENDA_SANITARIA_LABEL)}</span>
          <Item
            name={AZIENDA_SANITARIA}
            rules={[{ required: true, message: getMessageString(intl, AZIENDA_SANITARIA_MESSAGE) }]}
          >
            <Select
              placeholder={getMessageString(intl, AZIENDA_SANITARIA_PLACEHOLDER)}
              options={ospedali}
              onChange={onSelezioneAziendaSanitaria}
              aria-label={AZIENDA_SANITARIA}
            />
          </Item>
          <span className="itemLabel">{getMessageString(intl, STRUTTURA_SANITARIA_LABEL)}</span>
          <Item
            name={STRUTTURA_SANITARIA}
            rules={[
              {
                required: listaStrutture.length > 0 ? true : false,
                message: getMessageString(intl, STRUTTURA_SANITARIA_MESSAGE),
              },
            ]}
          >
            <Select
              placeholder={getMessageString(intl, STRUTTURA_SANITARIA_PLACEHOLDER)}
              options={listaStrutture}
              disabled={!selectStruttureEnabled}
              aria-label={STRUTTURA_SANITARIA}
            />
          </Item>
          <span className="itemLabel">{getMessageString(intl, ID_PAZIENTE_LABEL)}</span>
          <Item name={ID_PAZIENTE} rules={[{ required: true, message: getMessageString(intl, ID_PAZIENTE_MESSAGE) }]}>
            <Input placeholder={getMessageString(intl, ID_PAZIENTE_PLACEHOLDER)} aria-label={ID_PAZIENTE} />
          </Item>
          <Button htmlType="submit" style={{ display: "none" }}>
            Submit
          </Button>
        </Form>
        <Row {...(mobileMode && { className: "buttonContainer" })}>
          <Col lg={{ span: 1 }}>
            <Button onClick={onSubmit}>{getMessageString(intl, ACCEDI)}</Button>
          </Col>
          <Col lg={{ span: mobileMode ? 4 : 22, offset: mobileMode ? 0 : 1 }}>
            <Button onClick={resetFields}>{getMessageString(intl, RESET)}</Button>
          </Col>
          {/* {mobileMode && (
            <Col lg={{ span: 2, offset: 17 }}>
              <Button icon={<QrcodeOutlined />} onClick={onOpenScanner}>
                {getMessageString(intl, ACQUISIZIONE_FOTOCAMERA)}
              </Button>
            </Col>
          )} */}
        </Row>
        {modalVisible && (
          <QRCodeScanner
            isVisible={modalVisible}
            onClose={() => setModalVisible(false)}
            onScan={onScanSuccess}
            onError={(e) => console.log("QR CODE SCANNER ERROR", e)}
          />
        )}
      </div>
    </Spin>
  );
};
export const Cerca = withRouter(injectIntl(CercaBase));
